import React, { useRef, useState, useEffect } from 'react';
import s from '../SliderBigText.module.css';
import { useParams } from "react-router-dom";
import { useAppTranslation } from "./TranslationContext";

export const SliderBigText = () => {
  const [data, setData] = useState([]);
  const { id } = useParams();
  const { t } = useAppTranslation();

  const slidesRef = useRef(null);
  const [currentStep, setCurrentStep] = useState(0);
  const [step, setStep] = useState(0);
  const [maxRightClicks, setMaxRightClicks] = useState(0);

  useEffect(() => {
    fetch(`https://api.rasulova-academy.uz/api/comment-kurs/?kurs=${id}`)
      .then((res) => {
        if (!res.ok) throw new Error("Error" + res.status);
        return res.json();
      })
      .then((comments) => {
        const initialData = comments.map((c) => ({
          ...c,
          photo: "https://api.rasulova-academy.uz/media/dt_pic.jpg",
          firstName: "",
          lastName: ""
        }));
        setData(initialData);

        comments.forEach((comment, index) => {
          const userId = comment.user;
          if (!userId) return;

          Promise.allSettled([
            fetch(`https://api.rasulova-academy.uzapi/custom-users/?user=${userId}`)
              .then((res) => res.ok ? res.json() : [])
              .then((userData) => userData?.[0]?.img || "https://api.rasulova-academy.uz/media/dt_pic.jpg")
              .catch(() => "https://api.rasulova-academy.uz/media/dt_pic.jpg"),

            fetch(`https://api.rasulova-academy.uz/api/users/${userId}/`)
              .then((res) => res.ok ? res.json() : {})
              .then((userInfo) => ({
                firstName: userInfo?.first_name || "",
                lastName: userInfo?.last_name || ""
              }))
              .catch(() => ({ firstName: "", lastName: "" }))
          ])
          .then(([photoResult, nameResult]) => {
            setData((prev) => {
              const updated = [...prev];
              updated[index] = {
                ...updated[index],
                photo: photoResult.value || photoResult,
                firstName: nameResult.value?.firstName ?? nameResult.firstName,
                lastName: nameResult.value?.lastName ?? nameResult.lastName
              };
              return updated;
            });
          });
        });
      })
      .catch(() => {});
  }, [id]);

  // Авторасчет step и maxRightClicks
  useEffect(() => {
    if (!slidesRef.current) return;
    const updateSizes = () => {
      const slideElement = slidesRef.current.querySelector(`.${s.slide}`);
      if (slideElement) {
        const slideWidth = slideElement.offsetWidth + 32; // +gap
        setStep(slideWidth);

        const visibleSlides = Math.floor(slidesRef.current.offsetWidth / slideWidth);
        setMaxRightClicks(Math.max(0, data.length - visibleSlides));
      }
    };
    updateSizes();
    window.addEventListener('resize', updateSizes);
    return () => window.removeEventListener('resize', updateSizes);
  }, [data]);

  const moveLeft = () => {
    if (currentStep > 0) {
      const newStep = currentStep - 1;
      setCurrentStep(newStep);
      slidesRef.current.style.transform = `translateX(${step * -newStep}px)`;
    }
  };

  const moveRight = () => {
    if (currentStep < maxRightClicks) {
      const newStep = currentStep + 1;
      setCurrentStep(newStep);
      slidesRef.current.style.transform = `translateX(${step * -newStep}px)`;
    }
  };

  return (
    <div className={s.slider}>
      <div className={s.slider__left__right__btn}>
        <p className={s.slider__title}>{t('commentTitle')}</p>
        <div className={s.btns}>
          <button className={s.mvl} onClick={moveLeft} disabled={currentStep === 0}>
            <img className={s.slider__button__prev} src="https://cdn-icons-png.flaticon.com/128/130/130882.png" alt="prev" />
          </button>
          <button className={s.mvr} onClick={moveRight} disabled={currentStep === maxRightClicks}>
            <img className={s.slider__button__next} src="https://cdn-icons-png.flaticon.com/128/130/130882.png" alt="next" />
          </button>
        </div>
      </div>
      <div className={s.slides} ref={slidesRef}>
        {data.map((slide, index) => (
          <div className={s.slide} key={index}>
            <img className={s.slide__img} src={slide.photo} alt="user" />
            <div className={s.slide__contents}>
              <p className={s.slide__text}>{slide.comment}</p>
              <div className={s.slide__jobs}>
                <p>
                  {(slide.firstName || slide.lastName)
                    ? `${slide.firstName} ${slide.lastName}`.trim()
                    : "Без имени"}
                  <span className={s.material}></span> {slide.to}
                </p>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};
